define('plugin/ai-booking/AiBookingPlugin',['require','lib/plugin/PluginAbstract'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');

    return PluginAbstract.extend({

        widgetNode: null,

        initStepManagerEvents: function () {
            this.initEvents();
        },

        initEvents: function(){
            var pageChannel = Backbone.Wreqr.radio.channel('page');
            pageChannel.vent.on('shown', _.bind(function (){
                this.attachWidget();
            }, this));
            Backbone.history.on('route', _.bind(function (){
                this.attachWidget();
            }, this));
        },

        attachWidget: function () {
            var container = jQuery('#sb_ai_widget_container');
            var widget = jQuery('#sb_ai_widget');

            if (widget.length) {
                this.widgetNode = widget;
            }

            if (container.length && container.is(':visible') && this.widgetNode) {
                container.append(this.widgetNode);

                setTimeout(function (){ // need for changing tooltip position
                    window.dispatchEvent(new Event('resize'));
                }, 500)
            } else {
                jQuery('body').append(this.widgetNode);
            }
        }

    });

});
